import { styled } from '@mui/material/styles'
import { Box, CircularProgress } from '@mui/material'

export const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.neutral900,
}))

export function CircularLoading({ ...props }) {
  return (
    <Box sx={{ minWidth: 'fit-content', display: 'flex', marginLeft: '10px' }}>
      <StyledCircularProgress {...props} />
    </Box>
  )
}
